import { ObjectType, productDetails } from '../../../shared/utils/product-details-helpers';
import values from 'lodash/values';
import { TFunction } from 'i18next';

export const mapAgeGroup = (
    ageGroup: string | null | undefined,
    ageCategoryData: ObjectType | undefined,
    t: TFunction
) => {
    const ageGroupData = productDetails.getAgeGroups(ageCategoryData?.currentKey ?? '');
    Object.entries(ageGroupData.all).forEach(([key]) => {
        ageGroupData.all[key] = t(`yourLocalContent.yourTitles.dropdowns.ageGroup.${key}`, key);
    });

    if (ageGroup && values(ageGroupData.all).indexOf(ageGroup) >= 0) {
        ageGroupData.currentKey = ageGroup;
        ageGroupData.current = t(`yourLocalContent.yourTitles.dropdowns.ageGroup.${ageGroup}`, ageGroup);
    } else if (ageCategoryData?.currentKey) {
        ageGroupData.current = t('yourLocalContent.yourTitles.dropdowns.ageGroup.All');
        ageGroupData.currentKey = 'All';
    } else {
        ageGroupData.current = t('yourLocalContent.yourTitles.select');
    }

    return { ageGroupData };
};
